module.exports = __webpack_public_path__ + "img/icon-ai.3a685645.svg";